import { fromJS } from 'immutable';
import { FETCH_POS_DATA } from '@olxbr/mojo-jojo/constants';
import * as types from './constants';

const defaultState = fromJS({
  exitPopup: {
    visible: false,
    target: '',
  },

  olxProPopup: false,
  currentStep: null,
  loading: true,
  selectedCharacteristic: 0,
  modal: {
    visible: false,
  },
});

const toggle = (state, stateName) =>
  state.set(stateName, !state.get(stateName));

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.UI_SHOW_EXIT_POPUP: {
      return state
        .setIn(['exitPopup', 'visible'], true)
        .setIn(['exitPopup', 'target'], action.target);
    }

    case types.UI_HIDE_EXIT_POPUP: {
      return state
        .setIn(['exitPopup', 'visible'], false);
    }

    case types.UI_CHANGE_CURRENT_STEP: {
      return state
        .set('currentStep', action.visibleStep);
    }

    case types.UI_TOGGLE_OLX_PRO_POPUP: {
      return toggle(state, 'olxProPopup');
    }

    case types.UI_TOGGLE_LOADING: {
      return toggle(state, 'loading');
    }

    case FETCH_POS_DATA: {
      const defaultStep = action.payload.steps.find(step => step.default);
      return toggle(state, 'loading')
        .set('currentStep', defaultStep.name);
    }

    case types.UI_SELECTED_CHARACTERISTIC: {
      return state
        .set('selectedCharacteristic', action.selectedCharacteristic);
    }

    case types.UI_SHOW_MODAL: {
      return state
        .setIn(['modal', 'visible'], true);
    }

    case types.UI_HIDE_MODAL: {
      return state
        .setIn(['modal', 'visible'], false);
    }

    default:
      return state;
  }
};
